import { defineComponent } from '@nuxtjs/composition-api';
import { useDuck } from '~/services';
import { presets as gridPresets } from '~/composables/grid/video';
import { cachePage, createHead } from '~/utils';
import { VIDEO_LISTS } from '~/constants';
/**
 * Duck service.
 */
const duck = useDuck();
/**
 * Columns
 */
const columns = {
    desktop: 2,
    desktopMedium: 2,
    desktopWide: 3,
    mobile: 1,
    mobileMedium: 1,
    mobileWide: 1,
    tablet: 2,
};
export default defineComponent({
    name: 'PageVideo',
    setup() {
        return {
            columns,
        };
    },
    async asyncData(context) {
        const { app, env, error, req, res, route } = context;
        try {
            const lists = VIDEO_LISTS;
            const sections = {};
            const tasks = await Promise.allSettled(Object.keys(lists).map(async (id) => {
                const { data } = await duck.pub.getPubListById(id);
                return data;
            }));
            for (const task of tasks) {
                if (task.status === 'rejected') {
                    continue;
                }
                const list = task.value;
                sections[list.slug] = {
                    articles: list.articles?.map((article) => article.data) || [],
                    presets: gridPresets.map((preset) => {
                        return preset.map((card) => {
                            const options = card.options || {};
                            return {
                                ...card,
                                options: {
                                    ...options,
                                    title: list.name,
                                    titleTo: lists[list.slug] || '',
                                    moreTo: lists[list.slug] || '',
                                },
                            };
                        });
                    }),
                    title: list.name,
                    to: lists[list.slug] || '',
                };
            }
            const title = 'Видео';
            const head = {
                canonical: env.HOST + route.path,
                title,
                url: env.HOST + route.path,
            };
            context.$page = app.$page = {
                title,
            };
            if (process.server) {
                const [sectionKey] = Object.keys(sections);
                const section = sections[sectionKey];
                if (section) {
                    const [firstArticle] = section.articles;
                    if (firstArticle) {
                        const date = firstArticle.changed || firstArticle.time || firstArticle.created;
                        cachePage({ date, req, res });
                    }
                }
            }
            return {
                $page: context.$page,
                head,
                sections,
                title,
            };
        }
        catch (e) {
            console.error(e);
            error({ statusCode: 404 });
        }
    },
    head() {
        return createHead(this.head);
    },
});
